import * as React from 'react';

function SvgFastFoward(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.635 9.385v11.352a.75.75 0 001.134.644l8.577-5.111v4.653a.75.75 0 001.135.644L25 15.887a.75.75 0 000-1.288l-9.52-5.673a.75.75 0 00-1.134.644v4.288L5.77 8.741a.75.75 0 00-1.134.644zm9.711 4.473v2.412l.942-.562a.75.75 0 000-1.288l-.942-.562zm-8.211-3.153l7.305 4.359-7.305 4.353v-8.712zm17.016 4.539l-7.305-4.353v8.711l7.305-4.358z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgFastFoward;
